module.exports = __webpack_public_path__ + "static/coinex-7c43f60fa15ee4256ac6005db3c7cbda.webp";